// @flow
import type { GlobalState } from '../../../main/types/redux';
import type { UserState } from '../types';

export const getUserState = (state: GlobalState): UserState => state.user;
